// extracted by mini-css-extract-plugin
module.exports = {"box":"DebugBox_box__2_7px"};